

























import { Component, Vue } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';
import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import Mixin from '../mixin';

@Component
export default class NewOrganization extends Mixin {
  @State private showOrg!: string;
  private email: string = '';
  private nickname: string = '';

  @Mutation private organizationAdd!: (org: any) => void;

  private mounted() {
    (this.$el.querySelector('#nickname') as HTMLInputElement).focus();
  }

  private async upload(event: any) {
    if (this.nickname.length < 1) {
      this.msg('表示名称を入力してください');
      (this.$el.querySelector('#nickname') as HTMLInputElement).focus();
      return;
    }
    if (this.email.length < 1) {
      this.msg('メールアドレスを入力してください');
      (this.$el.querySelector('#email') as HTMLInputElement).focus();
      return;
    }
    if (document.querySelector('#email:invalid')) {
      this.confirm('メールの形式が正しくないようです。処理を続行しますか?', () => this.post(event));
    } else {
      this.post(event);
    }
  }

  private async post(event: any) {
    try {
      event.target.disabled = true;
      await API.post('api', '/member/new', {
        headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
        body: {Name: this.email, Nickname: this.nickname, Email: this.email, OrganizationID: this.showOrg },
      });
      this.msg('メンバーを追加しました');
      this.$router.go(-1);
    } catch (ex) {
      if (ex.response && ex.response.status === 409) {
        this.msg('団体に登録済みメールアドレスです');
        return;
      }
      this.msg(ex);
    } finally {
      event.target.disabled = false;
    }
  }
}

